// P0 — 1-Tap-Stempel-Chip im Handy-Header (nur Mitarbeiter, nur mobil via Sidebar-Guard).
// Zeigt Live-Status und führt mit einem Tap zur Stempeluhr.
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Clock } from "lucide-react";
import { API } from "../../utils/constants";

const MAP = {
  off:      { label: "Stempeln", color: "#9aa0a6" },
  working:  { label: "Im Dienst", color: "#2e7d32" },
  on_break: { label: "Pause",     color: "#b26a00" },
};

export const MobileStempelChip = () => {
  const navigate = useNavigate();
  const [state, setState] = useState("off");

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/time-clock/me/status`);
      if (r.data?.state) setState(r.data.state);
    } catch (_e) { /* still zeigen als 'Stempeln' */ }
  }, []);

  useEffect(() => {
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, [load]);

  const cfg = MAP[state] || MAP.off;

  return (
    <button
      type="button"
      data-testid="mobile-stempel-chip"
      onClick={() => navigate("/zeiterfassung")}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: "6px 10px", borderRadius: 999, border: "none", cursor: "pointer",
        background: cfg.color, color: "#fff", fontSize: 12, fontWeight: 600,
      }}
      aria-label={`Stempeluhr — Status: ${cfg.label}`}
    >
      <Clock size={14} />
      <span>{cfg.label}</span>
    </button>
  );
};

export default MobileStempelChip;
